<!-- add broker popup -->
<p-dialog
  [dismissableMask]="true"
  [(visible)]="addEditUserPopup"
  (onHide)="onHide()"
  [modal]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'addDealer-popup'"
  [closable]="false"
  (click)="closeModalOutside($event)"
>
  <ng-template pTemplate="content">
    <div
      class="container-addDealer-popup content-dialog"
      (click)="$event.stopPropagation()"
    >
      <div class="header">
        <h2>
          {{ isAddNew ? "Add New" : "Edit" }}
          {{ whoEntered.form }}
        </h2>
      </div>
      <form
        [formGroup]="addUserForm"
        #form="ngForm"
        (ngSubmit)="saveUser()"
        novalidate
      >
        <div
          *ngIf="
            isSubUserForm || (!isAddNew && whoEntered.form === 'Dealer Group')
          "
          class="group"
        >
          <div class="form-group">
            <label for="" class="form-label">Owner Name (First Name)</label>
            <input
              type="text"
              formControlName="fname"
              class="form-control"
              placeholder=""
            />
            <app-form-errors [color]="'danger'" [form]="form" [control]="fname">
            </app-form-errors>
          </div>
          <div class="form-group">
            <label for="" class="form-label">Owner Name (Last Name)</label>
            <input
              type="text"
              formControlName="lname"
              class="form-control"
              placeholder=""
            />
            <app-form-errors [color]="'danger'" [form]="form" [control]="lname">
            </app-form-errors>
          </div>
        </div>
        <div
          class="form-row"
          *ngIf="isAddNew && whoEntered.form !== 'Dealer Group'"
        >
          <app-input-field
            [type]="InputFieldType.Checkbox"
            [showLabel]="false"
            [label]="'Send Invitation Via Email'"
            [form]="addUserForm"
            [controlName]="'send_invitation'"
          ></app-input-field>
        </div>
        <div
          *ngIf="
            (isSubUserForm || whoEntered.form !== 'Agent') &&
            whoEntered.form !== 'Broker' &&
            (whoEntered.form !== 'Dealer Group' ||
              (whoEntered.form === 'Dealer Group' && !isAddNew))
          "
          class="form-group"
        >
          <label for="" class="form-label">Email</label>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            placeholder=""
          />
          <app-form-errors [color]="'danger'" [form]="form" [control]="email">
          </app-form-errors>
        </div>

        <div
          *ngIf="
            whoEntered.form !== 'Dealer Group' ||
            (whoEntered.form === 'Dealer Group' && !isAddNew)
          "
          class="form-group"
        >
          <label for="" class="form-label">Phone Number</label>
          <input
            type="text"
            class="form-control"
            formControlName="phone"
            mask="(000) 000-0000"
            [validation]="true"
            [dropSpecialCharacters]="false"
          />
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="addUserForm.controls['phone']"
          >
          </app-form-errors>
        </div>
        <div class="form-group">
          <label for="" class="form-label"
            >{{ whoEntered.form }} Name
            <i
              *ngIf="isLoadingTheProducts"
              class="fa-spin fas fa-spinner ms-2"
            ></i>
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="client_name"
          />
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="client_name"
          >
          </app-form-errors>
        </div>

        <div *ngIf="!isAddNew && whoEntered.form === 'Dealer Group'">
          <label class="form-label">Contact Information</label>
          <div formArrayName="contacts">
            <ng-container
              *ngFor="let contact of contactsFormArray?.controls; let i = index"
            >
              <div [formGroupName]="i" class="contact">
                <div class="d-flex justify-content-between mb-2">
                  <label class="form-label">Contact {{ i + 1 }}</label>
                  <div
                    class="product_delete-icon pointer"
                    (click)="deleteContact(i)"
                    *ngIf="
                      contactsFormArray?.controls?.length &&
                      contactsFormArray.controls.length > 1
                    "
                  >
                    <img src="./assets/images/trash2.png" alt="trash-icon" />
                  </div>
                </div>
                <div class="form-group">
                  <label for="" class="form-label">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    formControlName="email"
                    placeholder=""
                  />
                  <app-form-errors
                    [color]="'danger'"
                    [control]="contactsFormArray.at(i).get('email')"
                  >
                  </app-form-errors>
                </div>
                <div class="form-group">
                  <label for="" class="form-label">Phone Number</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="mobile"
                    mask="(000) 000-0000"
                    [validation]="true"
                    [dropSpecialCharacters]="false"
                  />
                  <app-form-errors
                    [color]="'danger'"
                    [control]="contactsFormArray.at(i).get('mobile')"
                  >
                  </app-form-errors>
                </div>
              </div>
            </ng-container>
            <div class="d-flex justify-content-end">
              <button
                [disabled]="
                  !contactsFormArray.value[contactsFormArray.value.length - 1]
                    ?.email &&
                  !contactsFormArray.value[contactsFormArray.value.length - 1]
                    ?.mobile
                "
                class="outline-btn"
                (click)="addContact()"
              >
                + Add Contact
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="isSubUserForm" class="form-group">
          <div class="auto-complete form-element w-100">
            <label class="form-label"> Parent </label>
            <p-autoComplete
              class="w-100"
              formControlName="parent_id"
              [completeOnFocus]="true"
              [multiple]="false"
              (completeMethod)="parentFilter.onQueryChange($event)"
              (onSelect)="parentFilter.onSelected($event)"
              [suggestions]="parentFilter.suggestions"
              field="third_party_info.name"
              placeholder="Search To Select Parent"
              appendTo="body"
              (onShow)="parentFilter.paginationScrolling()"
            >
            </p-autoComplete>
          </div>
        </div>
        <div *ngIf="whoEntered.form !== 'Dealer Group'" class="form-group">
          <div class="auto-complete form-element w-100">
            <label
              class="form-label"
              [class.required]="products?.hasValidator(Validators.required)"
            >
              Products
            </label>
            <p-autoComplete
              class="w-100"
              formControlName="products"
              [disabled]="whoEntered.from === 'producer'"
              [multiple]="true"
              (completeMethod)="productFilter.onQueryChange($event)"
              (onSelect)="productFilter.onSelected($event)"
              [suggestions]="productFilter.suggestions"
              field="label"
              placeholder="Search To Select Product"
              appendTo="body"
              (onShow)="productFilter.paginationScrolling()"
            >
            </p-autoComplete>
            <app-form-errors
              [color]="'products'"
              [form]="form"
              [control]="products"
            >
            </app-form-errors>
          </div>
          <div *ngIf="!isSubUserForm" class="auto-complete form-element w-100">
            <label
              class="form-label"
              [class.required]="products?.hasValidator(Validators.required)"
            >
              Internal Code
            </label>
            <input
              type="text"
              class="form-control"
              formControlName="internal_code"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="internal_code"
            >
            </app-form-errors>
          </div>
        </div>
        <div
          *ngIf="
            whoEntered.form !== 'Dealer Group' &&
            !isSubUserForm &&
            whoEntered.createdUsers &&
            whoEntered.from == 'admin'
          "
          class="form-group"
        >
          <div class="auto-complete">
            <label for="agent" class="form-label"
              >{{ sliceCreatedUser(whoEntered.createdUsers) }} Name
              <i
                *ngIf="isLoadingTheProducts"
                class="fa-spin fas fa-spinner ms-2"
              ></i>
            </label>
            <p-autoComplete
              class="w-100"
              formControlName="created_name"
              [disabled]="isLoadingTheProducts"
              (completeMethod)="clientsCreatedFilter.onQueryChange($event)"
              (onSelect)="clientsCreatedFilter.onSelected($event)"
              [suggestions]="clientsCreatedFilter.suggestions"
              field="third_party_info.name"
              placeholder="Select"
              appendTo="body"
              [completeOnFocus]="true"
              (onShow)="clientsCreatedFilter.paginationScrolling()"
            >
            </p-autoComplete>
            <app-form-errors
              [color]="'danger'"
              [form]="form"
              [control]="created_name"
            >
            </app-form-errors>
          </div>
        </div>
        <app-address-component
          *ngIf="whoEntered.form !== 'Dealer Group'"
          [isLoading]="isLoadingTheProducts"
          [addressForm]="formAddress"
        >
        </app-address-component>

        <div
          class="onboarding-form-options-container form-group"
          *ngIf="isAddNew && whoEntered.form !== 'Dealer Group'"
        >
          <div
            class="onboarding-list"
            (cdkDropListDropped)="drop($event)"
            cdkDropList
          >
            <ng-container
              *ngIf="!isLoadingOnboarding"
              formArrayName="formArray"
            >
              <ng-container
                *ngFor="
                  let onboard of getFormsArray(addUserForm.get('formArray'));
                  let i = index
                "
              >
                <div
                  [formGroupName]="i"
                  class="form-check"
                  cdkDrag
                  cdkDragBoundary=".onboarding-list"
                >
                  <div class="example-custom-placeholder" *cdkDragPlaceholder>
                    {{ onboard?.controls["title"]?.value }}
                  </div>
                  <div class="drag-icon" cdkDragHandle>
                    <img src="./assets/images/aligne-start2.svg" alt="" />
                  </div>
                  <div class="group">
                    <input
                      class="form-check-input"
                      [formControlName]="'check'"
                      type="checkbox"
                      value=""
                      id="req-{{ onboard?.controls['onboardIngId']?.value }}"
                    />
                    <!-- (click)="openOnboardingInNewWindow('onboarding/agreement/broker')"  -->
                    <label
                      class="form-check-label"
                      for="req-{{ onboard?.controls['onboardIngId']?.value }}"
                    >
                      {{ onboard?.controls["title"]?.value }}
                    </label>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <div
            *ngIf="
              addUserForm.controls['formArray'].invalid &&
              addUserForm.controls['formArray'].touched &&
              getFormsArray(addUserForm.get('formArray')).length == 0
            "
            class="general-error"
            style="color: red; font-size: 14px"
          >
            *You must add requirement
          </div>
          <!--
        <div *ngIf="getFormsArray(addUserForm.get('formArray')).length>0 && addUserForm.controls['formArray'].hasError('noCheck')" class="general-error" style="color: red;font-size: 14px;">
            *At least choose one item
        </div> -->

          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="addUserForm.get('formArray')"
          >
          </app-form-errors>

          <ng-container *ngIf="isLoadingOnboarding">
            <div class="form-check" style="display: block; padding: 0">
              <ngx-skeleton-loader
                appearance="line"
                [theme]="{
                  'border-radius': '5px',
                  height: '30px',
                  'max-width': '180px'
                }"
              ></ngx-skeleton-loader>
            </div>
            <div class="form-check" style="display: block; padding: 0">
              <ngx-skeleton-loader
                appearance="line"
                [theme]="{
                  'border-radius': '5px',
                  height: '30px',
                  'max-width': '180px'
                }"
              ></ngx-skeleton-loader>
            </div>
          </ng-container>

          <div
            *ngIf="whoEntered.from == 'admin'"
            (click)="saveDataInLocalStorage()"
            class="add-more-requirement"
          >
            + Add Additional Requirement
          </div>
        </div>

        <div
          *ngIf="isSubUserForm && whoEntered.form === 'Agent'"
          class="form-group"
        >
          <p>Enable Notifications:</p>
          <div class="d-flex gap-3 mb-2">
            <p-inputSwitch
              formControlName="enable_claim_creation_notification"
            ></p-inputSwitch>
            <label>Claim Creation</label>
          </div>
          <div class="d-flex gap-3 mb-2">
            <p-inputSwitch
              formControlName="enable_claim_status_update_notification"
            ></p-inputSwitch>
            <label>Claim Status Update</label>
          </div>
          <div class="d-flex gap-3">
            <p-inputSwitch
              formControlName="enable_claim_agent_change_notification"
            ></p-inputSwitch>
            <label>Claim Agent Change</label>
          </div>
        </div>

        <div class="footer-form">
          <div class="cancel-btn" (click)="closeModalOutside($event)">
            Cancel
          </div>
          <button
            type="submit"
            [disabled]="loadingSubmit"
            class="create-btn custom-btn"
          >
            {{ isAddNew ? "Send Now" : "Update" }}
            <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</p-dialog>

<!-- confirmation message -->
<app-confirmation-msg
  class="conformation"
  #messageComponent
  [isLoading]="loadingConfirm"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to discard your data?'"
>
</app-confirmation-msg>
